
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"as"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"uberadmin"},{"kind":"EnumValue","value":"learner"}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pawnId"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"pawnId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"assignmentHandle"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"main","block":false}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devTags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smart_goal_p_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_p_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_p_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_p_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_p_5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_o_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_o_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_o_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_o_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_o_5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_i_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_i_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_i_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_i_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_i_5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_s_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_s_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_s_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_s_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_s_5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_e_1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_e_2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_e_3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_e_4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"smart_goal_e_5"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":965}};
    doc.loc.source = {"body":"query($pawnId: Int) {\n    flows(as: [uberadmin, learner]) {\n        assignmentProgress(pawnId: [$pawnId], assignmentHandle: [\"main\"]) {\n            devTags {\n                smart_goal_p_1\n                smart_goal_p_2\n                smart_goal_p_3\n                smart_goal_p_4\n                smart_goal_p_5\n                smart_goal_o_1\n                smart_goal_o_2\n                smart_goal_o_3\n                smart_goal_o_4\n                smart_goal_o_5\n                smart_goal_i_1\n                smart_goal_i_2\n                smart_goal_i_3\n                smart_goal_i_4\n                smart_goal_i_5\n                smart_goal_s_1\n                smart_goal_s_2\n                smart_goal_s_3\n                smart_goal_s_4\n                smart_goal_s_5\n                smart_goal_e_1\n                smart_goal_e_2\n                smart_goal_e_3\n                smart_goal_e_4\n                smart_goal_e_5\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
